import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Lightbulb, Eye } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 24, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  const floatingVariants = {
    animate: {
      y: [-8, 8, -8],
      transition: {
        duration: 12,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="gradient-bg"></div>
        <div className="floating-elements">
          <motion.div 
            className="floating-icon icon-1"
            variants={floatingVariants}
            animate="animate"
          >
            <Palette size={40} />
          </motion.div>
          <motion.div 
            className="floating-icon icon-2"
            variants={floatingVariants}
            animate="animate"
            transition={{ delay: 1 }}
          >
            <Lightbulb size={35} />
          </motion.div>
          <motion.div 
            className="floating-icon icon-3"
            variants={floatingVariants}
            animate="animate"
            transition={{ delay: 2 }}
          >
            <Eye size={30} />
          </motion.div>
        </div>
      </div>

      <div className="container">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-logo" variants={itemVariants}>
            <img src="/assets/jmb-logo-branco-500.png" alt="JMB Design" />
            <div className="logo-lines">
              <div className="line line-1"></div>
              <div className="line line-2"></div>
              <div className="line line-3"></div>
            </div>
          </motion.div>

          <motion.h1 className="hero-title" variants={itemVariants}>
            <span className="title-line-1">DESIGN QUE</span>
            <span className="title-line-2">INSPIRA</span>
            <span className="title-accent">& TRANSFORMA</span>
          </motion.h1>

          <motion.p className="hero-subtitle" variants={itemVariants}>
            Criando identidades visuais únicas que conectam marcas aos seus públicos 
            através do poder do design inovador e funcional.
          </motion.p>

          <motion.div className="hero-stats" variants={itemVariants}>
            <div className="stat">
              <span className="stat-number">25+</span>
              <span className="stat-label">Anos de Experiência</span>
            </div>
            <div className="stat">
              <span className="stat-number">200+</span>
              <span className="stat-label">Projetos Realizados</span>
            </div>
            <div className="stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Clientes Satisfeitos</span>
            </div>
          </motion.div>

          <motion.div className="hero-actions" variants={itemVariants}>
            <a href="#portfolio" className="btn btn-primary">
              Ver Portfólio
            </a>
            <a href="#contact" className="btn btn-outline">
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                  </svg>
                </div>
              </div>
              <span>Fale Comigo</span>
            </a>
          </motion.div>
        </motion.div>
      </div>

      {/* <motion.div 
        className="scroll-indicator"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 0.6 }}
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ArrowDown size={24} />
        </motion.div>
        <span>Role para descobrir</span>
      </motion.div> */}
    </section>
  );
};

export default Hero;
